import React from "react";
import AmountSelector from "./AmountSelector";
import Explanation from "./Explanation";

function ConfigTextCheckboxButton(props: {
    fullwidth?: true;
    selected?: boolean;
    name: string;
    value: string;
    callback: (value: string) => void
    image?: string,
    amount?: {
        min: number,
        max: number
    }
}) {


    return <>
        <div className="config-button-container flex-row">
            <div className="config-button-container">


            <label className={
                    "config-button configurator-button-w100"

                    + (props.selected ? " selected" : "")
                    + (props.fullwidth ? " fullwidth" : "")
            }
                   htmlFor={`${props.name}-${props.value}`}>
                <input
                        type={"checkbox"}
                        value={props.value}
                        id={`${props.name}-${props.value}`}
                        name={props.name}
                        style={{
                            display: "none",
                        }}
                        checked={props.selected ? true : undefined}
                        onClick={() => props.callback(props.value)}
                />
                {props.value}
                {props.image && <>&nbsp;
                </>}
            </label>

            {/*<Explanation>*/}
            {/*    <img src={`./configurator_images/${props.image}`} className={"explanation_image"}/>*/}
            {/*</Explanation>*/}


            {props.image && props.image !== "tech/none.png" && (
                    <Explanation>
                        <img src={`./configurator_images/${props.image}`} className={"explanation_image"}/>
                    </Explanation>
            )}
            </div>
            {props.amount && props.selected &&
                    <div className={'amount-container'}>
                        <AmountSelector name={props.value} min={props.amount.min} max={props.amount.max}/>
                    </div>
            }
        </div>
    </>
            ;


}

export default ConfigTextCheckboxButton;
